module.exports = __webpack_public_path__ + "img/android-icon-96x96.df914496.png";